import { base64ToBlob } from '@/lib/form';
import axios from '../../lib/axios';

function stringToSeconds(str) {
  const tokens = str.split(':');
  if (tokens.length === 3) {
    return Number(tokens[0]) * 3600 + Number(tokens[1]) * 60 + Number(tokens[2]);
  } else if (tokens.length === 2) {
    return Number(tokens[0]) * 60 + Number(tokens[1]);
  } else if (tokens.length === 1) {
    return Number(tokens[0]);
  }
  return 0;
}

export default {
  saveTag({ state, commit }, id) {
    const data = state.currentTag;
    data.videoId = state.video.id;
    data.event = state.video.event;
    if (id) {
      data.beginTime = stringToSeconds(data.begin);
      data.endTime = stringToSeconds(data.end);
    }
    return axios.post(`videotags${id ? `/${id}` : ''}`, data).then(res => {
      commit('tagSaved', res.data);
    });
  },

  removeTag({ commit }, id) {
    return axios.delete(`videotags/${id}`).then(res => {
      commit('tagDeleted', res.data.id);
    });
  },

  downloadTag({ commit }, id) {
    return axios.get(`videotags/download/${id}`).then(res => {
      commit('tagDownloaded', res.data.id);
    });
  },

  /* eslint no-unused-vars: 0 */
  downloadMultiTag({ commit }, ids) {
    return axios.get(`videotags/multidownload/${ids}`);
  },

  saveLayout({ commit }, payload) {
    return axios.post('videotags/layout', payload).then(res => {
      commit('updateLayout', res.data);
    });
  },

  loadLayout({ commit }) {
    return axios.get('videotags/layout').then(res => {
      commit('updateLayout', res.data);
    });
  },

  getBoardBackground({ state, commit }) {
    return axios.get('videotags/board/background', { params: { time: state.currentTime, videoId: state.video.id,  event: state.video.event} }).then(res => {
      commit('setBackgroundImage', res.data);
    });
  },

  saveTacticalBoard({ state, commit }) {
    if (state.canvas.export && state.canvas.image) {
      const formData = new FormData();
      var id = state.currentBoard ? state.currentBoard.id : null;
      formData.append('time', state.currentTime);
      formData.append('tagId', state.currentTag ? state.currentTag.id : null);
      formData.append('canvas', state.canvas.export);
      formData.append('width', state.canvas.width);
      formData.append('height', state.canvas.height);
      const png = state.canvas.image.split(',')[1];
      const file = base64ToBlob(png, 'image/png');
      formData.append('image', file);
      return axios.post(`videotags/board/save${id ? `/${id}` : ''}`, formData).then(res => {
        commit('boardSaved', res.data);
      });
    }
    return null;
  },
  removeTacticalBoard({ commit }, id) {
    return axios.delete(`videotags/board/${id}`).then(res => {
      commit('boardDeleted', res.data);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/videotags/actions.js